import React from 'react';
import {useAccountType} from '@/context/AccountTypeContext';
import {HostList} from '@/components/HostList';

/**
 * Global game-host admin page. The list, filters, stats, actions, and modal all
 * live in the shared <HostList/>; this page is just the header + scope.
 */
export const ManageGameHost: React.FC = () => {
    const {labels, accountType} = useAccountType();

    return (
        <div className="p-6 space-y-6">
            <div>
                <h1 className="text-2xl font-bold text-gray-900">Manage {labels.hostPlural}</h1>
                <p className="mt-1 text-sm text-gray-500">
                    {accountType === 'business'
                        ? `Create and manage ${labels.hostPlural.toLowerCase()} across all business accounts`
                        : `Create and manage ${labels.hostPlural.toLowerCase()} across all ${labels.accountPlural.toLowerCase()}`}
                </p>
            </div>

            <HostList showStats/>
        </div>
    );
};
